/**
 * API Base URL resolver — picks the safest backend host at runtime.
 *
 * Why: at build time `process.env.REACT_APP_BACKEND_URL` is inlined as a
 * literal string into the JS bundle (e.g. `https://web-design-builder-3.emergent.host`).
 * On the Production deployment under `alphalane-tradingsystems.com`, the
 * customer's browser then has to do cross-domain requests to a third
 * subdomain — which corporate firewalls, ad-blockers and disabled
 * third-party cookies frequently block, surfacing as the dreaded
 * "Network Error" with no HTTP status.
 *
 * Fix: when the page is being served from the canonical Production
 * domain, we POST same-origin (`/api/...`). Otherwise we fall back to
 * the env var so Preview, localhost-dev and Storybook keep working.
 */
const PRODUCTION_HOSTS = new Set([
  "alphalane-tradingsystems.com",
  "www.alphalane-tradingsystems.com",
]);

function resolveBackendUrl() {
  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname || "";
    if (PRODUCTION_HOSTS.has(host)) {
      // Same-origin — browser never has to traverse a different domain.
      return window.location.origin;
    }
  }
  return (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;
